
    import { Component, Model, Prop, Vue, Watch } from 'vue-property-decorator';
    import _ from 'lodash';
    import Patient from '@/types/Patient';
    import api from '@/services/Api';
    import axios, { AxiosResponse, CancelTokenSource } from 'axios';
    import { VAutocomplete } from '@/types/Components';

    export type PatientSearchItem = {
        name?: string;
        id?: number;
        geburtsDatum?: string;
        adresse?: string;
        divider?: boolean;
        telefon?: string;
        telefon2?: string;
    };

    export type PatientSearchFilter = {
        patnr?: number;
    };

    @Component
    export default class PatientSearch extends Vue {
        @Model('change') data!: PatientSearchItem[];
        @Prop({ default: () => ({ patnr: undefined })}) filter!: PatientSearchFilter;

        public $refs!: {
            search: VAutocomplete;
        };

        public search = null;
        public select: PatientSearchItem | null = null;
        public loading = false;

        public source: CancelTokenSource | null = null;
        public searchApiCall: _.DebouncedFunc<(query: string) => void> | null = null;

        @Watch('search', { immediate: true })
        public searchChange(search: string): void {
            search && search !== (this.select?.name ?? '') && this.querySelections(search);
        }

        @Watch('select')
        public onChangeSelect(select: PatientSearchItem): void {
            this.$emit('select', select);
        }

        public reset(): void {
            this.$refs.search.reset();
            this.$refs.search.blur();
        }

        public mounted(): void {
            this.search = null;
            this.select = null;
        }

        public destroyed(): void {
            if (this.source) {
                this.source.cancel('cancel ivs/patienten/search');
            }
        }

        public onClickEnter(): void {
            const query = this.search ?? '';
            if (query.length === 0) {
                this.searchPatient(query);
            }
        }

        public querySelections(search: string | null): void {
            const query = search ?? '';
            if (query.length < 3) {
                return;
            }

            this.searchPatient(query);
        }

        public searchPatient(query: string): void {
            this.loading = true;

            if (!this.searchApiCall) {
                this.searchApiCall = _.debounce((query: string) => {
                    if (this.source) {
                        this.source.cancel('cancel ivs/patienten/search');
                    }

                    this.source = axios.CancelToken.source();

                    api.post('ivs/patienten/search', { query, filter: this.filter }, { cancelToken: this.source.token })
                        .then((res: AxiosResponse) => {
                            const items: PatientSearchItem[] = [];

                            res.data.body
                                .map((data: Patient) => new Patient(data))
                                .forEach((patient: Patient, idx: number) => {
                                    items.push({
                                        name: patient.nachnameVornameTitel,
                                        id: patient.patnr as number,
                                        geburtsDatum: patient.geburtsdatum ?? '',
                                        adresse: patient.Adresse,
                                    });

                                    if (idx !== res.data.body.length - 1) {
                                        items.push({ divider: true });
                                    }
                                });

                            this.$emit('change', items);
                            this.loading = false;
                        })
                        .catch(console.error)
                        .finally(() => this.source = null);
                }, 500);
            }

            this.searchApiCall(query);
        }
    }
